/**
 * Fallback retez dle 10 §0: konkretni tag ('de-AT') -> primarni jazyk
 * ('de') -> en -> cs. Neznamy jazyk nikdy nespadne - vzdy skonci na cs.
 */
export function fallbackChain(localeTag) {
    const chain = [];
    const push = (tag) => {
        const t = tag?.trim();
        if (t !== undefined && t !== '' && !chain.includes(t))
            chain.push(t);
    };
    push(localeTag);
    push(localeTag?.split('-')[0]);
    push('en');
    push('cs');
    return chain;
}
//# sourceMappingURL=keys.js.map